var _excluded = ["checked", "disabled", "error", "fieldSize", "id", "indeterminate", "intensity", "name", "label", "required", "style", "tabIndex", "value"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable no-param-reassign */
import React, { useCallback, useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import { Intensities, Sizes } from "../../../constants.js";
import FieldLabel from "../FieldLabel/FieldLabel.js";
/* TYPES */
/* VISIBLE Checkbox BUTTON */
var StyledCheckboxButton = styled.div.withConfig({
  componentId: "CL__sc-6trwum-0"
})(["border:var(--checkbox-border-size) solid var(--border-color);border-radius:var(--checkbox-border-radius);display:block;height:var(--checkbox-size);left:0;position:absolute;top:var(--checkbox-top);transition:background-color var(--hover-transition),border-color var(--hover-transition);width:var(--checkbox-size);svg{display:block;height:100%;width:100%;left:0;opacity:0;position:absolute;top:0;transition:background-color var(--hover-transition),opacity var(--hover-transition),transform var(--hover-transition);path{fill:var(--highlight-color);}}svg.check-icon{transform:translateY(-25%);}"]);

/* INVISIBLE Checkbox BUTTON */
var CheckboxInput = styled.input.withConfig({
  componentId: "CL__sc-6trwum-1"
})(["clip-path:inset(50%);clip:rect(0 0 0 0);height:1px;overflow:hidden;margin:0;position:absolute;white-space:nowrap;width:1px;"]);

/* LABEL */
var StyledFieldLabel = styled(FieldLabel).withConfig({
  componentId: "CL__sc-6trwum-2"
})(["padding:0 var(--checkbox-margin) 0 calc(var(--checkbox-size) + var(--checkbox-margin));position:relative;"]);

/* MAIN CONTAINER - controls interaction styling and sizing */

var CheckboxContainer = styled.div.withConfig({
  componentId: "CL__sc-6trwum-3"
})(["align-items:center;cursor:", ";display:block;position:relative;&:hover ", ":not(:checked):not(:disabled) + ", "{border-color:var(--highlight-color);svg.check-icon{opacity:1;transform:translateY(0);path{fill:var(--border-color-dim);}}}&:active ", ":not(:checked):not(:disabled) + ", "{border-color:var(--link-color-hover);}& ", ":not(:checked):not(:disabled):focus-visible{box-shadow:0 0 5px var(--highlight-color);border-color:var(--highlight-color);+ ", " svg.check-icon{opacity:1;transform:translateY(0);path{fill:var(--border-color-dim);}}}& ", ":disabled + ", "{border-color:var(--border-color-dim);}& ", ":disabled + ", ":before{background-color:var(--border-color-dim);}& ", ":not(:disabled):checked + ", "{background-color:var(--highlight-color);border-color:var(--highlight-color);}& ", ":disabled:checked + ", "{background-color:var(--border-color-dim);border-color:var(--border-color-dim);}& ", ":checked + ", " svg.check-icon{opacity:1;transform:translateY(0);path{fill:var(--main-bkg-color);}}& ", ":not(:disabled):indeterminate + ", "{background-color:var(--highlight-color);border-color:var(--highlight-color);}& ", ":disabled:indeterminate + ", "{background-color:var(--border-color-dim);border-color:var(--border-color-dim);}& ", ":indeterminate + ", " svg.dash-icon{opacity:1;path{fill:var(--main-bkg-color);}}& ", ":not(:disabled):focus-visible + ", "{box-shadow:0 0 5px var(--highlight-color);border-color:var(--highlight-color);}", " ", " ", " ", ""], _ref => {
  var {
    $disabled
  } = _ref;
  return $disabled ? 'default' : 'pointer';
}, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, CheckboxInput, StyledCheckboxButton, _ref2 => {
  var {
    error
  } = _ref2;
  return error && "\n    & ".concat(StyledCheckboxButton, " {\n      border-color: var(--error-color);\n    }\n\n    &:hover ").concat(CheckboxInput, ":not(:disabled) + ").concat(StyledCheckboxButton, " {\n      border-color: var(--error-color);\n    }\n\n    & ").concat(CheckboxInput, ":not(:disabled):checked + ").concat(StyledCheckboxButton, ",\n    & ").concat(CheckboxInput, ":not(:disabled):indeterminate + ").concat(StyledCheckboxButton, " {\n      border-color: var(--error-color);\n    }\n\n    & ").concat(CheckboxInput, ":checked + ").concat(StyledCheckboxButton, ",\n    & ").concat(CheckboxInput, ":indeterminate + ").concat(StyledCheckboxButton, " {\n      background-color: var(--error-color);\n    }\n\n    & ").concat(CheckboxInput, ":not(:disabled):focus-visible + ").concat(StyledCheckboxButton, " {\n      box-shadow: 0 0 5px var(--error-color);\n      border-color: var(--error-color);\n    }\n    ");
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return fieldSize === Sizes.LARGE ? "\n    --checkbox-size: var(--spacing-4);\n    --checkbox-border-radius: 3px;\n    --checkbox-top: 0;\n    --checkbox-bullet-size: var(--spacing-2);\n    --checkbox-margin: var(--spacing-2);\n    --checkbox-border-size: 2px;\n    " : "";
}, _ref4 => {
  var {
    fieldSize
  } = _ref4;
  return fieldSize === Sizes.MEDIUM ? "\n    --checkbox-size: var(--spacing-3);\n    --checkbox-border-radius: 3px;\n    --checkbox-top: 3px;\n    --checkbox-bullet-size: calc(var(--spacing-1) + 2px);\n    --checkbox-margin: calc(var(--spacing-1) + 2px);\n    --checkbox-border-size: 2px;\n    " : "";
}, _ref5 => {
  var {
    fieldSize
  } = _ref5;
  return fieldSize === Sizes.SMALL ? "\n    --checkbox-size: var(--spacing-2);\n    --checkbox-border-radius: 2px;\n    --checkbox-top: 3px;\n    --checkbox-bullet-size: var(--spacing-1);\n    --checkbox-margin: var(--spacing-1);\n    --checkbox-border-size: 1px;\n    " : "";
});
var Checkbox = /*#__PURE__*/React.forwardRef((_ref6, ref) => {
  var {
      checked = false,
      disabled = false,
      error = false,
      fieldSize = Sizes.MEDIUM,
      id = '',
      indeterminate = false,
      intensity = Intensities.LIGHT,
      name = '',
      label,
      required = false,
      style,
      tabIndex = 0,
      value
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded);
  // Indeterminate state needs to be set via the input element
  // Need to ensure there's a ref present in the correct format
  // or merge refs when one is passed in
  var inputRef = useRef(null);
  var setRefs = useCallback(node => {
    inputRef.current = node;
    if (node) node.indeterminate = indeterminate;
    if (!ref) return;
    if (typeof ref === 'function') ref(node);else ref.current = node;
  }, [ref]);
  useLayoutEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return /*#__PURE__*/React.createElement(CheckboxContainer, {
    indeterminate: indeterminate,
    $disabled: disabled,
    error: error,
    fieldSize: fieldSize,
    style: style
  }, /*#__PURE__*/React.createElement(CheckboxInput, _extends({
    "aria-checked": indeterminate ? 'mixed' : checked,
    checked: checked,
    disabled: disabled,
    id: id,
    name: name,
    ref: setRefs,
    required: required,
    tabIndex: tabIndex,
    type: "checkbox",
    value: value
  }, props)), /*#__PURE__*/React.createElement(StyledCheckboxButton, null, indeterminate ? /*#__PURE__*/React.createElement("svg", {
    className: "dash-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 52h60v16H30z"
  })) : /*#__PURE__*/React.createElement("svg", {
    className: "check-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1 42.8L85.6 33 96 43.6 53.7 87 24 56.7 34.4 46.1 53.7 65.7 76.1 42.8Z"
  }))), /*#__PURE__*/React.createElement(StyledFieldLabel, {
    disabled: disabled,
    fieldSize: fieldSize,
    htmlFor: id,
    intensity: intensity,
    required: required
  }, label));
});
export default Checkbox;